module.exports = __webpack_public_path__ + "static/media/linkedin.0f9733fa.svg";